module.exports = __webpack_public_path__ + "img/mapinnerHide.8cb80dc5.svg";